import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../App";
// import "./AuditionCardReuse.css";

const TablePaginationReuse = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data, tableHead, isJuryB } = props;

 

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <>
        <div className="py-3">
          <div className="row mx-1" style={{ overflowX: "auto" }}>
            <Table
              className="table w-100"
              striped
              bordered
              hover
              variant="dark"
            >
              <thead>
                <tr>
                  {tableHead &&
                    tableHead.map((heading) => (
                      <th className="bg-warning text-center">{heading}</th>
                    ))}
                </tr>
              </thead>

              <tbody>
                {currentItems ? (
                  currentItems.map((user, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        {user.participant?.first_name}{" "}
                        {user.participant?.last_name}
                      </td>
                      <td className="text-center">{user.participant?.email}</td>
                      <td className="text-center">
                        <div className="row">
                          {user?.videos?.map((video, i) => (
                            <div key={i} className="col-md-4">
                              <ReactPlayer
                                controls
                                url={videoCdnUrl + video.video}
                                width="200px"
                                height="100px"
                              />
                              <span>Mark</span> :{" "}
                              {isJuryB ?
                               ( <span>{video.group_b_jury_mark}</span>)
                               :( <span>{video.group_c_jury_mark}</span>)}
                             
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <h3 className="text-danger">No Data Found</h3>
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div id="react-paginate">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            breakLinkClassName={"page-link"}
            containerClassName={"pagination"}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </>
    </>
  );
};

export default TablePaginationReuse;
